export default {"src":"/_next/static/media/fa-solid_university.51b3c042.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};